//Campaign list + CRUD
export const GET_QUIZ_CAMPAIGNS = "GET_QUIZ_CAMPAIGNS";
export const GET_QUIZ_CAMPAIGN = "GET_QUIZ_CAMPAIGN";
export const INSERT_QUIZ_CAMPAIGN = "INSERT_QUIZ_CAMPAIGN";
export const UPDATE_QUIZ_CAMPAIGN = "UPDATE_QUIZ_CAMPAIGN";
export const DELETE_QUIZ_CAMPAIGN = "DELETE_QUIZ_CAMPAIGN";

//Frequency choices, languages and rule limits, served by the backend
export const GET_QUIZ_FORM_OPTIONS = "GET_QUIZ_FORM_OPTIONS";

//Quizzes inside a campaign. A quiz is a single question — there is no separate
//"week" record, so these act directly on questions.
export const GET_QUIZZES = "GET_QUIZZES";
export const INSERT_QUIZ = "INSERT_QUIZ";
export const UPDATE_QUIZ = "UPDATE_QUIZ";
export const DELETE_QUIZ = "DELETE_QUIZ";

//Clears the selected campaign when leaving a detail screen
export const CLEAR_QUIZ_CAMPAIGN = "CLEAR_QUIZ_CAMPAIGN";

//Declared winners for a COMPLETED campaign — the admin-only variant that
//carries each winner's email (see quiz-campaign/:id/winners/admin).
export const GET_QUIZ_WINNERS = "GET_QUIZ_WINNERS";
